import Phaser from 'phaser';
import { makeMountWithRider } from '../render/mount';
import { GameState } from '../state/GameState';

export class WinScene extends Phaser.Scene {
  constructor() {
    super('WinScene');
  }

  create(): void {
    const W = this.scale.width;
    const H = this.scale.height;
    const bg = this.add.graphics();
    bg.fillGradientStyle(0xf2c14e, 0xf2c14e, 0xffe7a8, 0xffe7a8, 1);
    bg.fillRect(0, 0, W, H);

    this.add
      .text(W / 2, 140, 'YOU WIN!', {
        fontFamily: 'sans-serif',
        fontSize: '96px',
        color: '#3d2914',
        stroke: '#ffffff',
        strokeThickness: 6,
      })
      .setOrigin(0.5);
    this.add
      .text(W / 2, 220, 'You conquered all 25 levels and defeated the Mountain Dragon.', {
        fontFamily: 'sans-serif',
        fontSize: '22px',
        color: '#3d2914',
      })
      .setOrigin(0.5);

    const character = GameState.getCharacter(this.registry);
    const animal = GameState.getAnimal(this.registry);
    const display = makeMountWithRider(this, animal, character, W / 2, H / 2 + 80);
    display.setScale(3);
    this.tweens.add({
      targets: display,
      angle: { from: -3, to: 3 },
      duration: 700,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });

    const c = this.add.container(W / 2, H - 80);
    const btn = this.add.rectangle(0, 0, 240, 50, 0x3d2914).setStrokeStyle(2, 0xffffff);
    const t = this.add
      .text(0, 0, 'Back to Title', { fontFamily: 'sans-serif', fontSize: '22px', color: '#fff' })
      .setOrigin(0.5);
    c.add([btn, t]);
    c.setSize(240, 50).setInteractive({ useHandCursor: true });
    c.on('pointerdown', () => {
      // Don't wipe the slot — keep the completed save so the player can revisit.
      this.scene.start('TitleScene');
    });
  }
}
